export interface NavigationItem {
  title: string;
  short: string;
  route: string;
  protected?: boolean;
}

const navigationRoutes: NavigationItem[] = [
  {
    title: "Plantilla",
    short: "Plantilla",
    route: "/portada-canvas",
    protected: true,
  },
  {
    title: "CURP Generator",
    short: "CURP",
    route: "/curp-generator",
    protected: true,
  },
  {
    title: "CLABE",
    short: "CLABE",
    route: "/clabe-validator",
    protected: true,
  },
  {
    title: "Formación",
    short: "Formación",
    route: "/#formación",
  },
  {
    title: "Experiencia",
    short: "Experiencia",
    route: "/#experiencia",
  },
  {
    title: "Habilidades",
    short: "Habilidades",
    route: "/#habilidades",
  },
];

export default navigationRoutes;
